




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "phoneNumber",
})
export default class PhoneNumber extends Vue {
  @Prop({ type: Number, default: {} }) zIndex!: number;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    console.log("item---", value);
  }
}
